export const extractBulkInventoryValidationErrorMessage = err => {
  // Default fallback
  let errorMessage = err?.message || 'Unknown error';

  const axiosError = err?.response?.data;

  if (axiosError && typeof axiosError === 'object') {
    const keys = Object.keys(axiosError);

    if (keys.length > 0) {
      const firstKey = keys[0];
      const messageArray = axiosError[firstKey];

      if (Array.isArray(messageArray) && messageArray.length > 0) {
        errorMessage = `${firstKey}: ${messageArray[0]}`;
      }
    }
  }

  return errorMessage;
};
